import db from '../db'
import { Oferta } from '../interfaces'
import { derived } from 'svelte/store'
import { liveQuery as LQ } from 'dexie'
import { getDiffDate, resolveObjectKey, unflattenObject } from '$lib/utils'
import { liveQuery } from '../livequery'

// @ts-ignore
export const offers = liveQuery(db.ofertas, Oferta)
export function initialization(interval = 60000*3) {
    offers.init()
    const syncInterval = setInterval(() => {
        let lastUpdate
        offers.getLastUpdateState().subscribe((r) => lastUpdate = r)
        // @ts-ignore
        if (lastUpdate && Math.abs(Date.now() - lastUpdate.getTime()) >= interval) {
            offers.sync()
        }
    }, 1000)
    return [syncInterval, () => clearInterval(syncInterval)]
}
export const createDerived = cuit => LQ(async () => {
    // @ts-ignore
    return await db.ofertas
    .where({cuit})
    .toArray()
    .then(r => r.map(o => o.id_licitacion))
})

export const createDerivedWithFields = (cuit, fields) => LQ(async () => {
    // @ts-ignore
    return await db.ofertas
    .where({cuit})
    .toArray()
    .then(r => r.map(o => {
        return Object.fromEntries(
             fields.map(f => {
                let [F, rw] = f.split(':')
                return [rw || F, resolveObjectKey(F, o)]
            })
        )
    }))
})

async function checkEntriesAssert(ctx) {
    let ret = await ctx.collection
        .filter(item => 
            ['Ingresada'].includes(item.state) &&
            (getDiffDate(new Date(), new Date(item.creation_date)) > (86400*2)) // No se han actualizado en dos dias
        )
        .toArray()
        .then(r => r.map(o => o.id_oferta).filter(x => x))
    ctx.ret = ret
    console.log('LPP', ctx.ret)
    return ctx.ret.length > 0
}

export async function fixCallback(ctx) {
    await ctx.controller.get({
        'id_oferta[in]': ctx.ret.join(','),
        'limit': ctx.ret.length
    })
    .then(async res => await res.json())
    .then(r => ctx.controller.toItem(r))
    .then(r => r.map(i => ctx.controller.convert(i)))
    .then(async entries => {
        await ctx.collection.bulkPut(entries)
        console.log(`[DEXIE] UPDATED ${entries.length} ROWS`)
    })
}

// offers.setHook('afterRestore', async function() {
//     //@ts-ignore
//     offers.fixEntries([ checkEntriesAssert ], fixCallback)
// })

export const idTenderOffers = derived(offers, $offers => $offers ? $offers.map(o => o.id_licitacion) : [])
export default offers

